import React from 'react';
import ReactDOM from 'react-dom';
import {StaticRouter, BrowserRouter as Router, HashRouter} from 'react-router-dom';
import { createBrowserHistory } from "history";
import './index.css';
import App from './App';

const hist = createBrowserHistory();

//render through the client
const clientRender = () => {
    ReactDOM.render(
        <Router basename = "/"><App/></Router>, document.getElementById('root'));
};

//render throught the server
const serverRender = () => {
    const context = {};
    ReactDOM.render(
    <StaticRouter context={context}>
      <App />
    </StaticRouter>, document.getElementById('root'));
};

//
if (typeof window === 'object') {
    clientRender();
} else {
    serverRender();
};

